import ToolTip from "components/design/toolTip";
import Table from "../Table/V2/Table";
import classNames from "classnames";
import { MediumInfo } from "components/icons/MediumInfo";
import { Button } from "../Button/Button";
import { Label } from "../TextInput/TextInput";

export const HeadCellContent = ({
  title,
  infoText,
  sort,
  filter,
  align = "left",
  required = false,
}: {
  title: string;
  infoText?: React.ReactNode;
  sort?: {
    nextSortOrder: "asc" | "desc" | false;
    isSorted: "asc" | "desc" | false;
    sortingHandler?: (event?: unknown) => void;
  };
  filter?: React.ReactNode;
  align?: "left" | "center" | "right";
  required?: boolean;
}) => {
  return (
    <div className="t-flex t-items-center t-justify-center t-w-full">
      <div
        className={classNames("t-flex t-items-center t-gap-1 t-w-full", {
          "t-justify-start": align === "left",
          "t-justify-center": align === "center",
          "t-justify-end": align === "right",
        })}
      >
        <span className="t-text-subtext-sm t-text-text-30">
          <Label required={required} className="!t-pb-0">
            {title}
          </Label>
        </span>
        {infoText && (
          <ToolTip text={infoText}>
            <div className="t-flex t-items-center t-justify-center">
              <MediumInfo size={14} />
            </div>
          </ToolTip>
        )}
        {filter && <button className="all:unset">{filter}</button>}
        {sort && sort.sortingHandler && (
          <button className="all:unset" onClick={sort.sortingHandler}>
            <Table.HeadCellSort {...sort} />
          </button>
        )}
      </div>
    </div>
  );
};
